module.exports = __webpack_public_path__ + "131ad20c43de96d8d222c6b8fea2d2dc.svg";